import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75397e46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OTabelaAcordeaoProfissionais__InformacoesPessoais" }
const _hoisted_2 = { class: "OTabelaAcordeaoProfissionais__NomeEmail" }
const _hoisted_3 = { class: "OTabelaAcordeaoProfissionais__Nome" }
const _hoisted_4 = { class: "OTabelaAcordeaoProfissionais__Email" }

import { IProfissionais } from "@/types/profissionais"
  import Avatar from "primevue/avatar"
  import Column from "primevue/column"
  import DataTable from "primevue/datatable"
  import { tabelaProfissionais } from "./OTabelaAcordeaoProfissionais"

  interface Props {
    profissionais: IProfissionais[]
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaAcordeaoProfissionais',
  props: {
    profissionais: null
  },
  setup(__props: any) {

const props = __props as {
    profissionais: IProfissionais[]
  }

  

  const { filtros, profissionaisOrdenadosPorStatus, desativarLinhaPorStatus } =
    tabelaProfissionais(props.profissionais)

  const limitarTamanhoNome = (nome: string) => {
    return nome.length > 37 ? nome.slice(0, 37) + "..." : nome
  }

  const estilizarLabelAvatar = (label: string, avatar: string) => {
    if (avatar === "") {
      return ""
    } else {
      return ajustarNomeLabel(label)
    }
  }
  const ajustarNomeLabel = (nome: string) => {
    let nomeSeparado = nome.split(" ")

    const nomeSeparadoFiltrado = nomeSeparado.filter(
      (nomeFiltrado) => !/^(de)$|^(do)$|^(da)$|^(-)$|^(_)$/gi.test(nomeFiltrado)
    )

    return nomeSeparadoFiltrado[0][0] + nomeSeparadoFiltrado[1][0]
  }

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PButton = _resolveComponent("PButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_unref(DataTable), {
    filters: _unref(filtros),
    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filtros) ? (filtros).value = $event : null)),
    class: "OTabelaAcordeaoProfissionais",
    "current-page-report-template": "mostrando {first} a {last} de {totalRecords}",
    "data-key": "id",
    "data-testid": "OTabelaAcordeaoProfissionais",
    "filter-display": "menu",
    "global-filters-fields": ['nome', 'id'],
    paginator: "",
    "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
    "responsive-layout": "scroll",
    "row-class": _unref(desativarLinhaPorStatus),
    rows: 6,
    "striped-rows": "",
    value: _unref(profissionaisOrdenadosPorStatus)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        class: "OTabelaAcordeaoProfissionais__Column",
        field: "nome",
        header: "nome",
        sortable: ""
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Avatar), {
              class: "OTabelaAcordeaoProfissionais__Avatar",
              image: data.avatar,
              label: estilizarLabelAvatar(data.nome, data.avatar),
              shape: "circle"
            }, null, 8, ["image", "label"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(limitarTamanhoNome(data.nome)), 1),
              _createElementVNode("small", _hoisted_4, _toDisplayString(data.email), 1)
            ])
          ])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            placeholder: "pesquisar por nome",
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        class: "OTabelaAcordeaoProfissionais__Column",
        field: "id",
        header: "código"
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.id), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            placeholder: "pesquisar por código",
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        class: "OTabelaAcordeaoProfissionais__Column",
        field: "categoria",
        header: "categoria"
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.categoria.nome), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            placeholder: "pesquisar por categoria",
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        class: "OTabelaAcordeaoProfissionais__Column OTabelaAcordeaoProfissionais__Actions",
        field: "acoes",
        header: "",
        style: {"text-align":"end"}
      }, {
        body: _withCtx(() => [
          _withDirectives(_createVNode(_component_PButton, {
            class: "OTabelaAcordeaoProfissionais__IButton p-button-rounded",
            "data-testid": "OTabelaAcordeaoProfissionais__IButton",
            icon: "pi pi-trash"
          }, null, 512), [
            [
              _directive_tooltip,
              'arquivar',
              void 0,
              { top: true }
            ]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["filters", "row-class", "value"]))
}
}

})